<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync
                    ref="app"
                    :app="app"
                    :view="view"
                    :columns="columns"
                    :default-limit="20"
                    pagination="loadmore"
                    @edit="openForm"
                    slotRButton
                >
                    <template slot="head-right" slot-scope="data">
                        <!-- Descargar Informe -->
                        <a-tooltip placement="top">
                            <template slot="title"> Generar informe de proveedores </template>
                            <a-button :loading="downloading" @click="getInforme">
                                <fa-icon :icon="['fas', 'download']" />
                            </a-button>
                        </a-tooltip>
                    </template>
                    <template slot="name" slot-scope="{ item }">
                        <truncate tag="span" class="clickable" @click="$router.push(`/providers/${item._EntityId}`)">
                            {{ item.name }}
                        </truncate>
                    </template>
                    <template slot="alias" slot-scope="{ item }">
                        <small>
                            {{ item.alias }}
                        </small>
                    </template>
                    <template slot="address" slot-scope="{ item }">
                        <truncate tag="small">
                            {{ item.address }}<br />
                            {{ item.location ? item.location : '' }}
                            {{ item.state ? ', ' + item.state : '' }}
                        </truncate>
                    </template>

                    <template slot="actions" slot-scope="{ item }">
                        <g-item-actions app="providers" :item="item" @edit="openForm">
                            <template slot="left">
                                <a-button
                                    @click="$router.push({ name: 'providerInfo', params: { id: item._EntityId } })"
                                >
                                    <fa-icon :icon="['far', 'eye']" />
                                </a-button>
                            </template>
                        </g-item-actions>
                    </template>
                </g-table-sync>

                <!-- <app-list
					ref="app"
					:permalink="app"
					:view="view"
					:fields="columns"
					@edit="openForm"
				>
					<template
						slot="address"
						slot-scope="{item}"
					>
						<small>
							{{ item.address }}
							{{ item.location ? ', '+ item.location : '' }}
							{{ item.state ? ', '+ item.state : '' }}</small>
					</template>

				</app-list> -->
            </div>
        </div>

        <custom-form :id="id" ref="form" :app="app" :view="view" :visible="formEnabled" @close="closeForm" />
    </div>
</template>

<script>
import customForm from './form'

export default {
    name: 'Providers',
    components: { customForm },
    data() {
        return {
            app: 'providers',
            view: 'providerList',
            columns: [
                {
                    title: 'ID',
                    index: '_EntityId',
                    search: true,
                },
                {
                    title: 'NIF/CIF',
                    width: '150px',
                    index: 'cif',
                    search: true,
                },
                {
                    title: 'Nombre',
                    index: 'name',
                    slot: 'name',
                    order: true,
                    search: true,
                },
                {
                    title: 'Teléfono',
                    index: 'phone',
                    search: true,
                    slot: '_phone',
                },
                {
                    title: 'Email',
                    index: 'email',
                    search: true,
                },
                {
                    title: 'Dirección',
                    index: 'address',
                    search: true,
                    slot: 'address',
                },
                {
                    title: 'Acciones',
                    slot: 'actions',
                },
            ],
            formEnabled: false,
            id: 0,
            downloading: false,
        }
    },
    created() {
        this.$hub.$on('newProvider', () => {
            this.id = 0
            this.formEnabled = true
        })
    },
    beforeDestroy() {
        this.$hub.$off('newProvider')
    },
    methods: {
        openForm(item) {
            this.id = item._EntityId
            this.formEnabled = true
        },
        closeForm() {
            this.id = 0
            this.formEnabled = false
        },
        async getInforme() {
            this.downloading = true

            try {
                const res = await this.$lambda.get(`/reports/${this.app}`, {
                    responseType: 'blob',
                })

                if (res.ok) {
                    const downloadUrl = window.URL.createObjectURL(res.data)
                    const a = document.createElement('a')
                    a.href = downloadUrl
                    a.download = 'reporteProveedores.pdf'
                    document.body.appendChild(a)
                    a.click()
                    URL.revokeObjectURL(downloadUrl)

                    this.$message.success('Informe generado. Descargando fichero...')
                } else {
                    this.$message.error('No se pudo completar la operación')
                    throw String('No se pudo completar la operación')
                }
            } catch (err) {
                console.error(err)
                this.downloading = false
                this.$message.error('Ocurrió un error en la generación del informe')
            } finally {
                this.downloading = false
            }
        },
    },
}
</script>

<style lang="scss">
.clickable {
    cursor: pointer;
}
</style>
